'use strict';
import template from './operacionesCorteMensual.html';
import controller from './operacionesCorteMensual.controller';

const OperacionesCorteMensualComponent = {
  controller,
  template
};

export default OperacionesCorteMensualComponent;



// WEBPACK FOOTER //
// ./src/app/components/operaciones/corteMensual/operacionesCorteMensual.component.js